import * as React from "react";
const SvgLockUnlocked20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M7.34 4.553C7.812 3.822 8.633 3 10 3c1.638 0 2.308.68 2.632 1.246A2.923 2.923 0 0 1 13 5.5V8H2v11h16V8h-3V5.5h-1l1-.001v-.027a2.658 2.658 0 0 0-.011-.204 4.926 4.926 0 0 0-.62-2.014C13.691 2.07 12.361 1 10 1 7.673 1 6.316 2.452 5.66 3.469l-.542.84 1.68 1.085.542-.84ZM13 10H4v7h12v-7h-3Z",
      clipRule: "evenodd"
    })
  );
export default SvgLockUnlocked20Px;
